import { isAddress, zeroAddress } from "viem";

const STORAGE_KEY = "futurex_referrer";

/** Persist `?ref=0x…` from the landing URL so it survives navigation until the first bid. */
export function captureReferral() {
    try {
        const ref = new URLSearchParams(window.location?.search)?.get("ref");
        if (ref && isAddress(ref)) localStorage.setItem(STORAGE_KEY, ref);
    } catch {
        /* storage unavailable — referral simply isn't remembered */
    }
}

/**
 * Referrer to pass to placeBid. The contract records it once, on a user's first bid, and
 * ignores it afterwards; a self-referral reverts, so it is replaced with the zero address.
 */
export function referrerFor(user, alreadyHasReferrer) {
    if (alreadyHasReferrer) return zeroAddress;
    try {
        const ref = localStorage.getItem(STORAGE_KEY);
        if (ref && isAddress(ref) && ref?.toLowerCase() !== user?.toLowerCase()) return ref;
    } catch {
        /* ignore */
    }
    return zeroAddress;
}
